"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CertificatesProvider = void 0;

var tslib_1 = require("tslib");

var Plugin_1 = require("@skbkontur/plugin-js/lib/Plugin");

var Log_1 = require("@skbkontur/plugin-js/lib/common/Log");

var CertificatesFetcher_1 = require("./CertificatesFetcher");

var StatusFetcher_1 = require("./StatusFetcher");

var constants_1 = require("../../utils/constants");

var StaticCertUpdateUtils_1 = require("./StaticCertUpdateUtils");

var CertificatesProvider =
/** @class */
function () {
  function CertificatesProvider(options) {
    var _this = this;

    this.options = options;
    this.items = [];
    this.active = false;
    this.completed = false;
    this.log = Log_1.LogManager.getLog(constants_1.LOG_PREFIX + "CertificatesProvider");

    this.start = function () {
      if (_this.active || _this.completed) {
        return;
      }

      _this.active = true;

      _this.certificatesFetcher.start();
    };

    this.stop = function () {
      _this.certificatesFetcher.stop();

      if (_this.statusFetcher) {
        _this.statusFetcher.stop();
      }

      _this.active = false;
    };

    this.isActive = function () {
      return _this.active;
    };

    this.isCompleted = function () {
      return _this.completed;
    };

    this.refreshItems = function () {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var certificateProcessor, certificateInfos, items;
        return tslib_1.__generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              certificateProcessor = this.options.certificateProcessor;
              certificateInfos = this.items.map(function (item) {
                return {
                  certificate: item.certificate,
                  storeInfo: item.storeInfo
                };
              });
              return [4
              /*yield*/
              , certificateProcessor.process(certificateInfos)];

            case 1:
              items = _a.sent();
              this.onFetchCertificates(items);
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    this.getAllItems = function () {
      return _this.items;
    };

    this.onError = function (error) {
      _this.stop();

      if ([Plugin_1.PluginErrors.PluginCommand, Plugin_1.PluginErrors.PluginTimeoutExpired].includes(error.code)) {
        /**
         * Если при получении сертификатов возникла ошибка c кодом PluginCommand значит плагин не может
         * получить сертификаты, обычно это из-за того что в хранилище есть сертификат, который плагин
         * "не может" получить. Пробуем переключиться на Тулбокс.
         */
        var toolboxSetupResult = _this.options.pluginFullInfo.fallback;

        if (toolboxSetupResult) {
          _this.log.warn("Switched to Toolbox, error: " + error.code + ", " + error.message);

          _this.trackEvent('toolboxFallback', error.code, {
            pluginVersion: _this.options.pluginFullInfo.pluginInfo.version,
            toolboxVersion: toolboxSetupResult.pluginInfo.version,
            message: error.message
          });

          _this.certificatesFetcher.setPluginInfo(toolboxSetupResult);

          if (_this.options.onToolboxFallback) {
            _this.options.onToolboxFallback();
          }

          _this.start();
        } else {
          _this.completed = true;

          _this.options.onError(error);
        }
      } else {
        _this.completed = true;

        _this.options.onError(error);
      }
    };

    this.onFetchStatus = function (newStatusMap) {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var items;
        return tslib_1.__generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              items = this.attachStatusInfo(this.items, newStatusMap);
              return [4
              /*yield*/
              , this.options.certificateProcessor.checkVisibilityByStatus(items)];

            case 1:
              items = _a.sent();
              this.setItems(items);
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    this.attachStatusInfo = function (certificateListItems, statusMap) {
      return certificateListItems.map(function (item) {
        var statusInfo = statusMap[item.certificate.thumbprint()];

        if (statusInfo === undefined) {
          return item;
        }

        var newThumbprint;

        if (statusInfo.NewThumbprint && typeof statusInfo.NewThumbprint === 'string') {
          newThumbprint = statusInfo.NewThumbprint.toLowerCase();
        }

        return tslib_1.__assign(tslib_1.__assign({}, item), {
          statusInfo: {
            status: statusInfo.Status,
            newFormId: statusInfo.NewFormId || undefined,
            rcPhone: statusInfo.RCPhone || undefined,
            newThumbprint: newThumbprint
          }
        });
      });
    };

    this.onFetchCertificates = function (items) {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var currentStatusMap;
        return tslib_1.__generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!this.statusFetcher) return [3
              /*break*/
              , 4];
              this.statusFetcher.setCertificateInfos(this.options.certificateProcessor.getValidItems(items));
              if (!this.statusFetcher.hasStatuses()) return [3
              /*break*/
              , 2];
              currentStatusMap = this.statusFetcher.getStatusMap();
              items = this.attachStatusInfo(items, currentStatusMap);
              return [4
              /*yield*/
              , this.options.certificateProcessor.checkVisibilityByStatus(items)];

            case 1:
              items = _a.sent();
              this.log.info('Attached previos or cached status info to certificates');
              this.setItems(items);
              return [3
              /*break*/
              , 3];

            case 2:
              if (this.options.CAParams.showWithoutStatus) {
                // Если статусов нет, то показываем без них.
                this.log.info('There are no status yet. Show certificates without status info');
                this.setItems(items);
              } else {
                this.log.info('There are no status yet. Parameter CAParams.showWithoutStatus: false. Wait for statueses');
                this.setItems(items, false);
              }

              _a.label = 3;

            case 3:
              if (!this.statusFetcher.isActive() && !this.statusFetcher.isCompleted()) {
                // запускаем statusFetcher если он не включен
                this.statusFetcher.start();
              }

              return [3
              /*break*/
              , 5];

            case 4:
              this.log.info('Status fetching not required. Return certificates without status info');
              this.setItems(items);
              _a.label = 5;

            case 5:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    this.setItems = function (items, publishItems) {
      if (publishItems === void 0) {
        publishItems = true;
      }

      var _a = _this.options,
          certificateProcessor = _a.certificateProcessor,
          staticCertUpdate = _a.staticCertUpdate;
      _this.items = items;
      var visibleItems = certificateProcessor.getVisibleItems(items);
      visibleItems = certificateProcessor.checkForDublicates(visibleItems);
      visibleItems = certificateProcessor.sortCertificates(visibleItems);
      var invalidItems = certificateProcessor.getInvalidItems(items);
      var validItems = certificateProcessor.getValidItems(items);
      /**
       * Обновление через статичные ссылки может включаться только
       * если не настроено обновление через статусы.
       */

      if (!_this.statusFetcher && staticCertUpdate) {
        visibleItems = StaticCertUpdateUtils_1.addStaticUpdateInfoToCertificates(visibleItems, staticCertUpdate);
      }

      _this.log.info('All processed certificates list items', items);

      _this.log.info('Valid certificates list items', validItems);

      _this.log.info('Visible certificates list items', visibleItems);

      _this.log.info('Invalid certificates list items', invalidItems);

      if (publishItems) {
        _this.options.onGetCertificates(visibleItems);
      }
    };

    this.trackEvent = options.trackEvent;
    this.certificatesFetcher = new CertificatesFetcher_1.CertificatesFetcher({
      caCabinetClient: options.caCabinetClient,
      ntrClient: options.ntrClient,
      certificateProcessor: options.certificateProcessor,
      installParams: options.installParams,
      fetchPeriod: options.certificatesFetchPeriod,
      pluginSetupResult: options.pluginFullInfo,
      onIterationComplete: this.onFetchCertificates,
      storeNames: options.storeNames,
      storeTypes: options.storeTypes,
      hasPrivateKey: options.hasPrivateKey,
      fetchCertificatesWithContent: options.fetchCertificatesWithContent,
      onError: this.onError,
      pluginRequestTimeout: options.pluginRequestTimeout,
      requisiteCertificateTypes: options.requisiteCertificateTypes,
      trackEvent: options.trackEvent
    });
    var CAParams = options.CAParams;

    if (CAParams) {
      this.statusFetcher = new StatusFetcher_1.StatusFetcher({
        issuers: CAParams.issuers,
        useCachedStatus: CAParams.useCachedStatus,
        fetchPeriod: CAParams.fetchPeriod,
        thumbprintPerRequest: CAParams.thumbprintPerRequest,
        maxErrorCount: CAParams.maxErrorCount,
        getStatus: CAParams.getStatus,
        onIterationComplete: this.onFetchStatus,
        trackEvent: options.trackEvent
      });
    }
  }

  return CertificatesProvider;
}();

exports.CertificatesProvider = CertificatesProvider;